<template>
  <div class="pay-page">
    <div class="banner-top">
      <div class="banner-box">在线支付</div>
    </div>
    <div class="pay-box">
      <div class="back-bar">
        <el-button size="small" icon="el-icon-arrow-left" @click="goBack">返回</el-button>
      </div>

      <div class="section-card">
        <div class="section-title">订单信息</div>
        <div class="info-list">
          <div class="info-item"><span class="label">订单编号：</span><span class="value">{{ order_id }}</span></div>
          <div class="info-item"><span class="label">应付金额：</span><span class="amount">￥{{ amount }}</span><span class="tax">（含税）</span></div>
          <div class="info-item"><span class="label">套餐名称：</span><span class="value">{{ package_name }}</span></div>
        </div>
      </div>

      <div class="section-card qr-card">
        <div class="section-title">请使用微信或支付宝扫码支付</div>
        <div class="qr-area">
          <div class="qr-box">
            <img src="/static/images/payQrcode.png" alt="支付二维码" class="qr-img" />
          </div>
           <div class="qr-box">
            <img src="/static/images/payQrcode2.png" alt="支付二维码" class="qr-img" />
          </div>
          <div class="qr-tip">
            <p>支付金额：<span class="pay-amount">￥{{ amount }}</span></p>
            <p>请使用 <b>微信</b> 或 <b>支付宝</b> 扫描上方二维码完成支付</p>
            <p>支付成功后，客服将在1个工作日内确认并开通服务权限</p>
            <p>如有疑问，请联系客服：13396040230（赵女士微信同号）</p>
          </div>
        </div>
      </div>

      <div class="action-bar">
        <el-button type="primary" class="btnBg" :loading="submitting" @click="confirmPay">我已完成支付</el-button>
        <el-button @click="goUCenter">查看订单</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { confirmTransfer } from "@/api/order";
export default {
  name: "OrderPay",
  data() {
    return {
      username: window.localStorage.getItem('username'),
      token: window.localStorage.getItem('token'),
      order_id: this.$route.query.order_id || '',
      amount: this.$route.query.amount || 0,
      package_name: this.$route.query.package_name || '',
      submitting: false,
    }
  },
  created() {
    this.$emit('header', true);
    this.$emit('footer', true);
  },
  methods: {
    confirmPay() {
      // 和转账一样，用户确认已支付，等待客服人工审核开通
      this.submitting = true;
      const data = {
        order_id: this.order_id,
        action: 'confirm_transfer',
      };
      // 未登录用户传 auto_register 信息
      if (!this.token) {
        const phone = sessionStorage.getItem('pendingPhone') || '';
        if (phone) {
          data.phone = phone;
          data.auto_register = true;
        }
      }
      confirmTransfer(data).then((response) => {
        this.submitting = false;
        if (response && (response.code === 2000 || response.code === 200)) {
          // 保存自动注册的账号信息
          if (response.data && response.data.account) {
            sessionStorage.setItem('newAccount', JSON.stringify(response.data.account));
          }
          this.$router.push({
            path: '/PaySuccess',
            query: {
              type: 'online',
              order_id: this.order_id,
            }
          });
        } else {
          this.$message.error({message: (response && response.msg) || '提交失败', duration: 2000, offset: 400});
        }
      }).catch((err) => {
        this.submitting = false;
        console.log(err);
        this.$message.error({message: '提交失败', duration: 2000, offset: 400});
      });
    },
    goBack() {
      this.$router.push({path: '/Order', query: {package_id: this.$route.query.package_id}});
    },
    goUCenter() {
      this.$router.push({path: '/UCenter'});
    },
  }
}
</script>

<style scoped>
.banner-top {
  width: 100%;
  height: 100px;
  margin-top: 50px;
  background: url("../assets/images/banner_top.png") no-repeat center / cover;
  text-align: center;
  color: #fff;
}
.banner-box {
  font-size: 30px;
  font-weight: 600;
  line-height: 100px;
}
.pay-box {
  width: 1200px;
  margin: 20px auto 40px;
}
.back-bar {
  margin-bottom: 16px;
}
.section-card {
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 20px 24px;
  margin-bottom: 20px;
}
.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #001646;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 16px;
}
.info-item {
  font-size: 15px;
  line-height: 36px;
  color: #313131;
}
.info-item .label {
  color: #898989;
}
.info-item .amount {
  color: #d4380d;
  font-size: 22px;
  font-weight: 700;
}
.info-item .tax {
  color: #d4380d;
  font-size: 13px;
  margin-left: 4px;
}
.qr-card {
  background: #f6f9ff;
  border: 1px solid #d6e4ff;
}
.qr-area {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 60px;
  padding: 30px 0 20px;
}
.qr-box {
  width: 220px;
  height: 220px;
  background: #fff;
  border: 1px solid #d6e4ff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.qr-img {
  width: 200px;
  height: 200px;
  object-fit: contain;
}
.qr-tip {
  font-size: 14px;
  line-height: 28px;
  color: #595959;
}
.qr-tip .pay-amount {
  color: #d4380d;
  font-size: 22px;
  font-weight: 700;
}
.action-bar {
  text-align: center;
  padding: 10px 0 20px;
}
>>> .action-bar .el-button {
  width: 200px;
  height: 44px;
  font-size: 15px;
  margin: 0 12px;
}
>>> .btnBg {
  background-color: #001646 !important;
  border-color: #001646 !important;
}
>>> .btnBg:hover,
>>> .btnBg:focus {
  background-color: #0a2a6e !important;
  border-color: #0a2a6e !important;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderPay.vue